import { __rest } from "tslib";
/**
 * 结标中车辆
 * */
import React, { Component } from 'react';
import { Table, Form, DatePicker, Row, Col, Modal } from 'antd';
import { connect } from '@souche-f2e/muji';
import { TableContainer, showInfo, UnitSearch, OperateShowMore, BuyerDistributor } from '@/components/index';
import { dispatch } from '@@/store';
import Authorized from '@/components/Auth/auth';
import { showCarDetail, fontEndConfig } from '@/shared/utils';
import { dealListValueShow, dealValueShow, dealTimeAnotherLine } from '@/shared/functions';
import moment from 'moment';
import { dealCar } from './index';
import { dealTableScroll } from './function';
const mapStateToProps = (rootState) => ({
    carState: rootState.carState,
});
class WaitDeal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clipped: [
                { dataIndex: 'carmodelName' },
                { dataIndex: 'vin' },
                { dataIndex: 'license' },
                { dataIndex: 'locationName' },
                { dataIndex: 'buyerType' },
                { dataIndex: 'commissionY' },
                { dataIndex: 'brokerageY' },
                { dataIndex: 'offerPriceY' },
                { dataIndex: 'highestOfferY' },
                { dataIndex: 'tradePriceY' },
                { dataIndex: 'times' },
            ],
            colums: [
                {
                    title: '车辆信息',
                    dataIndex: 'goodsId',
                    width: 400,
                    fixed: 'left',
                    render: (data, record) => {
                        const { reportResultType, goodsIdStr, carmodelName, firstImage, vin, license, locationName, rankDesc, rankLevel } = record;
                        return (<div className={'lefe_right_layout'}>
                <div className={'img_item'}>
                  <img src={firstImage} alt={carmodelName}/>
                </div>
                <div>
                  <div>
                    <a onClick={() => {
                            showCarDetail(goodsIdStr);
                        }}>
                      {carmodelName}
                    </a>
                  </div>
                  <div>{`VIN码：${dealValueShow(vin)}`}</div>
                  <div>
                    {reportResultType === 1 && (<img className={'report_268v'} src={require('@/assets/report/268v_2.png')} alt="268v"/>)}
                    <div className={'tag_item'}>{license}</div>
                    <div className={'tag_item'}>{locationName}</div>
                    <div className={'tag_item'}>
                      {dealValueShow((rankLevel + rankDesc) === 'undefined' ? fontEndConfig.noValueReplace : (rankLevel + rankDesc), false, fontEndConfig.noValueReplace)}
                    </div>
                  </div>
                </div>
              </div>);
                    },
                },
                {
                    title: '买家信息',
                    dataIndex: 'buyerCode',
                    wdith: 200,
                    render: (data, rowData) => {
                        const { buyerType } = rowData;
                        return (<div>
                <div>买家类型：{buyerType}</div>
                <BuyerDistributor record={Object.assign(Object.assign({}, rowData), { actionType: rowData.platformId, orderTag: 1 })}/>
                <div>
                  卖家经销商：
                  {rowData.sellerName ?
                            <a onClick={() => {
                                const { sellerCode } = rowData;
                                sellerCode && showInfo('seller', sellerCode);
                            }}>
                      {rowData.sellerName}
                    </a> :
                            fontEndConfig.noValueReplace}
                </div>
              </div>);
                    },
                },
                {
                    title: '竞拍信息',
                    className: 'tableColumn__addYuan',
                    dataIndex: 'price',
                    width: 200,
                    render: (data, rowData) => {
                        const { tradePriceY, offerPriceY, highestOfferY, brokerageY, commissionY } = rowData;
                        return (<div>
                <div>成交价 {tradePriceY}</div>
                <div>合手价 {offerPriceY}</div>
                <div>最高价 {highestOfferY}</div>
                <div style={{
                            fontSize: '10px',
                        }}>
                  {`佣金：${brokerageY}`}
                  &nbsp;&nbsp;
                  {`服务费：${commissionY}`}
                </div>
              </div>);
                    },
                },
                {
                    title: '上拍次数',
                    dataIndex: 'times',
                    width: 100,
                },
                {
                    title: '待成交时间',
                    dataIndex: 'willDealTime',
                    width: 150,
                    render(time) {
                        return time ? dealTimeAnotherLine(time) : fontEndConfig.noValueReplace;
                    },
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    width: 100,
                    fixed: 'right',
                    render: (text, record) => (<div>
              <OperateShowMore>
                <Authorized allow={'psgjb-cartransacpend-select'}>
                  <a luban-id="PSGJB-CAR-DCJCL-CJ" onClick={() => {
                        dealCar(record, () => {
                            dispatch.carState.updateWaitDealCar(0);
                        });
                    }}>
                    成交
                  </a>
                </Authorized>
                <Authorized allow={'psgjb-cartransacpend-select'}>
                  <a luban-id="PSGJB-CAR-DCJCL-LP" onClick={() => {
                        const { auctionIdStr } = record;
                        Modal.confirm({
                            title: '是否确认流拍？',
                            onOk() {
                                dispatch.carOperate.flowAuction({
                                    auctionId: auctionIdStr,
                                    callback: () => {
                                        dispatch.carState.updateWaitDealCar(0);
                                        dispatch.carState.getEveryStateCarNum({});
                                    },
                                });
                            },
                        });
                    }}>
                    流拍
                  </a>
                </Authorized>
                <a onClick={() => {
                        dispatch.router.push({
                            path: '/carManage/OfferDetails',
                            query: {
                                id: record.auctionIdStr,
                            },
                        });
                    }}>
                  出价详情
                </a>
                <a onClick={() => {
                        dispatch.router.push({
                            path: '/carManage/OfferCeneList',
                            query: {
                                id: record.auctionIdStr,
                                gd: record.goodsIdStr,
                            },
                        });
                    }}>
                  竞拍记录
                </a>
                <a onClick={() => {
                        dispatch.router.push({
                            path: '/carManage/Deal',
                            query: {
                                id: record.auctionIdStr,
                            },
                        });
                    }}>
                  处理
                </a>
              </OperateShowMore>
            </div>),
                },
            ],
            globalSearch: {},
            privateSearch: {
                status: 50,
                unitSearch: {},
            },
            unitList: [
                {
                    label: '买家经销商名称',
                    key: 'buyerName',
                },
                {
                    label: '买家经销商电话',
                    key: 'buyerPhone',
                },
            ],
        };
    }
    componentDidMount() {
        dispatch.carState.getEveryStateCarNum({});
        this.searchData(this.props.search);
    }
    search() {
        const { globalSearch, privateSearch } = this.state;
        const { unitSearch } = privateSearch, otherPrivate = __rest(privateSearch, ["unitSearch"]);
        const params = Object.assign(Object.assign(Object.assign({}, globalSearch), otherPrivate), unitSearch);
        dispatch.carState.SET_STATE({
            searchData: params,
        });
        dispatch.carState.updateWaitDealCar(1);
    }
    searchData(searchData) {
        const { provinceCode, cityCode, sellerCode } = searchData, otherSearchData = __rest(searchData, ["provinceCode", "cityCode", "sellerCode"]);
        this.setState({
            globalSearch: Object.assign(Object.assign({}, otherSearchData), { localProvinceCode: provinceCode, locationCode: cityCode, distributorCode: sellerCode }),
        }, () => {
            this.search();
        });
    }
    changePage(index) {
        dispatch.carState.updateWaitDealCar(index);
    }
    render() {
        const { tableData, isLoading, pageIndex, pageSize, tableTotal, searchData } = this.props.carState;
        const { colums, clipped, unitList } = this.state;
        const { dealColumns, scrollX } = dealTableScroll(colums);
        return (<React.Fragment>
        <TableContainer hasExport={true} exportObj={{
            type: 'auction',
            params: Object.assign(Object.assign({}, searchData), { exportType: 'auction_wait_deal_data' }),
            fileName: '车辆管理-结标中',
            allow: 'psgjb-cartransacpend-export',
        }}>
          <Row gutter={16} align={'middle'} type={'flex'} justify={'start'}>
            <Col span={6}>
              <UnitSearch queryList={unitList} onChange={(val) => {
            const { privateSearch } = this.state;
            const unitSearch = {};
            if (val) {
                const [searchKey, searchContent] = val.split('_');
                unitSearch[searchKey] = searchContent;
            }
            this.setState({
                privateSearch: Object.assign(Object.assign({}, privateSearch), { unitSearch }),
            }, () => {
                this.search();
            });
        }}/>
            </Col>
            <Col span={8}>
              <Form.Item label={'待成交时间'} colon={false} className={'search_time_label_border form_date_width_100'}>
                <DatePicker.RangePicker placeholder={['开始时间', '结束时间']} className={'width-100'} disabledDate={(currentDate) => {
            const now = moment();
            return currentDate > now;
        }} getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} onChange={(dates) => {
            let [startTime, endTime] = dates;
            startTime && (startTime = startTime.format('YYYY-MM-DD'));
            endTime && (endTime = `${endTime.format('YYYY-MM-DD')} 23:59:59`);
            const { privateSearch } = this.state;
            this.setState({
                privateSearch: Object.assign(Object.assign({}, privateSearch), { preStartDate: startTime, preEndTime: endTime }),
            }, () => {
                this.search();
            });
        }}/>
              </Form.Item>
            </Col>
          </Row>
          <Table className="draw_table_all_border scroll_table" loading={isLoading} columns={dealColumns} dataSource={dealListValueShow({
            gistData: clipped,
            data: tableData,
        })} scroll={{
            x: scrollX,
        }} rowKey={'auctionIdStr'} pagination={{
            current: pageIndex,
            pageSize,
            showQuickJumper: true,
            total: tableTotal,
            onChange: this.changePage,
            showTotal: total => `共${total}条`,
        }}/>
        </TableContainer>
      </React.Fragment>);
    }
}
export default connect(mapStateToProps, null, null, { forwardRef: true })(WaitDeal);
